import { defineStore } from 'pinia';
import { checkToken, setAuthToken } from '@/api/admin-be';
import { catchError } from '@/helpers/toast';

type AppStoreState = {
  token: string | null;
  userName: string | null;
  clipboard: string | null;
  acl: string[] | null;
};

export const useAppStore = defineStore('app', {
  state: () =>
    ({
      token: localStorage.getItem('token'),
      userName: localStorage.getItem('userName'),
      clipboard: null,
    }) as AppStoreState,
  actions: {
    async setUserName(userName: string) {
      localStorage.setItem('userName', userName);
      this.userName = userName;
    },
    async setToken(token: string | null) {
      setAuthToken(token);

      return checkToken()
        .then((acl: string[]) => {
          this.acl = acl;
          token && localStorage.setItem('token', token);
        })
        .catch((error) => {
          if (typeof error !== 'string') {
            return catchError('Истек срок действия токена', error)
          }
          localStorage.removeItem('token');
        })
        .finally(() => {
          this.token = localStorage.getItem('token');
        });
    },
    async copyToClipboard(text: string) {
      return navigator.clipboard.writeText(text).then(() => {
        this.clipboard = text;
        catchError('Скопировано в буфер', { message: text }, 'info');
      });
    },
    canReadSection(section: string): boolean {
      return !!(this.acl?.length && this.acl.find((i) => i === `r:${section}`));
    },
    canWriteSection(section: string): boolean {
      return !!(this.acl?.length && this.acl.find((i) => i === `w:${section}`));
    }
  },
});
